export default {
  ZH_HK: {
    publishinghouse: "出版社"
  },
  zh_cn: {
    publishinghouse: "出版社"
  },
  EN: {
    publishinghouse: "Publisher"
  },
  es: {
    publishinghouse: "Editorial"
  }
};
